import{jsx as e}from"react/jsx-runtime";import{hexToRgba as r,calculateRem as a,withVDSManager as o}from"@vds-core/utilities";import{ColorTokens as i}from"@vds-tokens/color";import t from"react-focus-lock";import n from"styled-components";import{FadeInAnimation as l,FadeOutAnimation as c,LoadingAnimation as d}from"./LoaderAnimations.js";import u from"./LoaderPortal.js";const s={active:!1,fullscreen:!1,surface:"light"},f=n.div.withConfig({displayName:"StyledOverlay",componentId:"VDS__sc-n1wne4-0"})`
  background-color: ${function({surface:e}){return r("dark"===e?i.background.primary.dark.value:i.background.primary.light.value,.8)}};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  position: ${function({fullscreen:e}){return e?"fixed":"absolute"}};
  display: ${function({active:e}){return e?"block":"none"}};
  animation: ${function({active:e}){return e?l:c}}
    0.15s linear;
`,m=n.div.withConfig({displayName:"StyledLoader",componentId:"VDS__sc-n1wne4-1"})`
  outline: none;
  content: '';
  position: ${function({fullscreen:e}){return e?"fixed":"absolute"}};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: ${a(40)};
  height: ${a(40)};
  display: block;
  z-index: 3;
  border: ${a(4)} solid
    ${function({surface:e}){return"dark"===e?i.elements.primary.ondark.value:i.elements.primary.onlight.value}};
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${d} 0.5s infinite linear;
`,p=function({active:r,fullscreen:a,id:o,surface:i}){return r?a?e(u,{"aria-label":"loader container",id:o,children:e(t,{children:e(f,{active:r,"aria-label":"loader overlay",fullscreen:a,surface:i,children:e(m,{tabIndex:0,"aria-label":"loader animation",surface:i})})})}):e(f,{active:r,"aria-label":"loader overlay",surface:i,children:e(m,{tabIndex:0,active:r,"aria-label":"loader animation",surface:i})}):null};p.defaultProps=s;var b=o(p);export{b as default,s as defaultProps};
